/*
 * @Author: your name
 * @Date: 2021-10-28 10:22:16
 * @LastEditTime: 2022-11-02 16:11:21
 * @LastEditors: WangZhengJie wangzj@geovis.com.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ngtc-traceability-admin\src\app\security\security.service.ts
 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { http } from '../utils/http';

@Injectable()
export class SecurityService {

    constructor(private http: http) { }

    private readonly TOKEN_KEY = 'ACCESS_TOKEN';

    public get token(): string | null {
        return localStorage.getItem(this.TOKEN_KEY);
    }

    public set token(token: string | null) {
        if (token) {
            localStorage.setItem(this.TOKEN_KEY, token);
        } else {
            localStorage.removeItem(this.TOKEN_KEY);
        }
    }

    private readonly USER_INFO_KEY = 'USER_INFO';

    //user: {account, ...}
    public get user(): any {
        return JSON.parse(localStorage.getItem(this.USER_INFO_KEY)!);
    }

    public set user(user: any) {
        if (user) {
            localStorage.setItem(this.USER_INFO_KEY, JSON.stringify(user));
        } else {
            localStorage.removeItem(this.USER_INFO_KEY);
        }
    }

    async login(formData: any): Promise<any> {
        return await this.http.post('auth/adminlogin', { ...formData, accountType: 'Account' }).toPromise() as any;
    }

    phoneLogin(formData: any) {
        return this.http.post('auth/expresslogin', { ...formData });
    }

    getVerifyCode(phone: string) {
        return this.http.get('auth/sendSmsCode');
    }

    bindPhone(formData: any) {
        return this.http.post('auth/bindPhone', { ...formData });
    }

    ssoLoginCheck(userInfo: any) {
        return this.http.post('user/ssoLoginUserCheck', { ...userInfo });
    }

    resetPasswordForForgetPassword(account: string, phone: string, code: string, password: string) {
        return this.http.post(`auth/resetPasswordForForgetPassword`, { account, phone, code, password });
    }

    async logout(): Promise<any> {
        this.user = null;
        this.token = null;
    }

}